// @ts-strict-ignore
import acceptedTalks from 'components/pages/dubbing/slug/accepted-talks.json';
import { Link } from 'components/router';
import useVideoPlayerStore from 'components/video-player-dubbing/store';
import { useSetSourceContext } from 'lib/business/source-context';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import SidebarVideo from '../SidebarVideo';
import RelatedVideosListProps from './RelatedVideosList.props';

/** List will render ideally with x2 related videos (initial), advertisement, x4 related videos (remaining) */
const RelatedVideosList = ({ id }: RelatedVideosListProps) => {
  const router = useRouter();

  const setSourceContext = useSetSourceContext('content_discovery_context');

  const expressPlaybackIntent = useVideoPlayerStore(
    state => state.expressPlaybackIntent
  );

  const reset = useVideoPlayerStore(state => state.reset);

  const playNextTalk = useCallback(
    () => () => {
      setSourceContext('talks-related');
      reset('nextTalk');
      expressPlaybackIntent(true);
    },

    [reset, expressPlaybackIntent]
  );

  const changeFirstPosition = (index: number) => {
    const firstPart = acceptedTalks.slice(0, index);
    const secondPart = acceptedTalks.slice(index);
    const newArray = secondPart.concat(firstPart);

    return newArray;
  };

  const renderVideoLink = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    relatedVideo: any,
    index: number
  ): React.ReactNode => {
    const href = {
      pathname: router.pathname,
      query: {
        ...router.query,
        slug: relatedVideo.slug
      }
    };

    return (
      <div key={index}>
        <Link
          onClick={playNextTalk()}
          isZenithLink
          key={relatedVideo.slug}
          href={href}
          className={`block pr-3 ${index === 0 ? 'pt-0' : 'pt-3'} `}
        >
          <SidebarVideo video={relatedVideo} />
        </Link>
      </div>
    );
  };

  return (
    <>
      {changeFirstPosition(acceptedTalks.findIndex(item => item.id === id))
        .filter(item => item.id !== id)
        .map(renderVideoLink)}
    </>
  );
};

export default RelatedVideosList;
